
  const sliders = document.querySelectorAll('.custom_blog_splide');
  sliders.forEach(function (splideEl) {
    new Splide(splideEl, {
     type: 'loop',
      perPage: 2,
      gap: '3rem',
      pagination: false,
      arrows: true,
      speed: 800,
      perMove: 1, 
      focus  : 0,
      autoplay: true,  
      omitEnd: true,
      interval: 4000,   
      throttle: 300,
      pauseOnHover: true,     
      pauseOnFocus: false,
      breakpoints: {
        1024: {
          perPage: 2,
          gap: '2rem'
        },
        767: {
          perPage: 2,
          gap: '1rem'
        },
        480: {
          perPage: 1,
          gap: '0.5rem'
        }
      }
    }).mount();
  });
  